module.exports = new __parcel__URL__("satheeh.16688e98.png").toString();